import React from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import {
    getProjectProductTagsByProjectProductIdAction,
    createProjectProductTagAction,
} from '../../redux/actions/projectProductTagActions';
import TagAssignmentModal from '../common/tagAssignmentModal/TagAssignmentModal';

interface Props {
    visible: boolean;
    projectProductId?: number | null;
    onClose: () => void;
    onSaved?: () => void;
}

const ProjectProductTagsModal: React.FC<Props> = ({ visible, projectProductId, onClose, onSaved }) => {
    const dispatch = useAppDispatch();
    const existingTags = useAppSelector((s) =>
        projectProductId
            ? (s as any).projectProductTagReducer.byProjectProductId[projectProductId]?.tags ?? []
            : []
    );
    const existingTagIds = existingTags.map((t: any) => t.tagId);

    return (
        <TagAssignmentModal
            visible={visible}
            existingTagIds={existingTagIds}
            onClose={onClose}
            onSaved={onSaved}
            onAssign={(tagId) =>
                dispatch(createProjectProductTagAction({ projectProductId: projectProductId!, tagId })) as Promise<unknown>
            }
            onRefresh={() =>
                projectProductId && dispatch(getProjectProductTagsByProjectProductIdAction(projectProductId))
            }
            inputId="add-project-product-tag-input"
        />
    );
};

export default ProjectProductTagsModal;
